import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SelectBlock from '../../../components/SelectBlock';

const proposalSections = [
  { key: 'general-information', label: 'General Information' },
  { key: 'proposal-content', label: 'Proposal Content' },
  { key: 'proposal-estimator', label: 'Proposal Estimator' },
  { key: 'contact-logs', label: 'Contact Logs' },
  { key: 'attachments', label: 'Attachments' },
  { key: 'reviewer-logs', label: 'Reviewer Logs' },
];

const ProposalMobileNavigation = ({ proposalId, proposal }) => {
  const history = useHistory();
  const location = useLocation();
  const currentSection =
    proposalSections.find((section) => location.pathname.includes(`/manage-proposal/${section.key}/`)) || proposalSections[0];
  const sectionOptions = proposalSections.map((section) => ({
    value: section.key,
    label: section.label,
  }));
  const selectedSection = sectionOptions.find((option) => option.value === currentSection.key);
  const isSubmitted = proposal.submittedBy && proposal.submittedBy !== '-';

  const navigateToSection = (selectedOption) => {
    if (selectedOption) {
      history.push(`/services/manage-proposal/${selectedOption.value}/${proposalId}`);
    }
  };

  return (
    <section className='aes-proposal-mobile-navigation d-lg-none' aria-labelledby='aes-proposal-mobile-navigation-title'>
      <div className='aes-proposal-mobile-navigation__summary'>
        <span className='aes-proposal-mobile-navigation__eyebrow'>Proposal Profile</span>
        <h2 id='aes-proposal-mobile-navigation-title' className='font-size-h2 font-weight-boldest'>
          {proposal.projectNumber ? `Project #${proposal.projectNumber}` : 'Proposal'}
        </h2>
      </div>

      <div className='aes-proposal-mobile-navigation__details'>
        {proposal.createdBy && (
          <div className='aes-proposal-mobile-navigation__detail'>
            <span>Created By</span>
            <strong>{proposal.createdBy}</strong>
          </div>
        )}
        {proposal.createdOn && (
          <div className='aes-proposal-mobile-navigation__detail'>
            <span>Created On</span>
            <strong>{proposal.createdOn}</strong>
          </div>
        )}
        {proposal.updatedBy && (
          <div className='aes-proposal-mobile-navigation__detail'>
            <span>Last Updated By</span>
            <strong>{proposal.updatedBy}</strong>
          </div>
        )}
        {proposal.updatedOn && (
          <div className='aes-proposal-mobile-navigation__detail'>
            <span>Last Updated On</span>
            <strong>{proposal.updatedOn}</strong>
          </div>
        )}
        {isSubmitted && (
          <>
            <div className='aes-proposal-mobile-navigation__detail'>
              <span>Submitted By</span>
              <strong>{proposal.submittedBy}</strong>
            </div>
            {proposal.submittedOn && proposal.submittedOn !== '-' && (
              <div className='aes-proposal-mobile-navigation__detail'>
                <span>Submitted On</span>
                <strong>{proposal.submittedOn}</strong>
              </div>
            )}
          </>
        )}
      </div>

      <SelectBlock
        label='Current section'
        className='aes-proposal-mobile-navigation__select'
        selectClassNamePrefix='aes-proposal-navigation-select'
        containerClassName='aes-proposal-mobile-navigation__select-container'
        options={sectionOptions}
        value={selectedSection}
        onChange={navigateToSection}
        isSearchable={false}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        }}
      />
    </section>
  );
};

export default ProposalMobileNavigation;
